import { useState, useEffect } from "react";
import API from "../services/api";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";


function UpdateAddress() {

    const [addressLine, setAddressLine] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [pincode, setPincode] = useState("")
    const [country, setCountry] = useState("")
    const [street, setStreet] = useState("")

    const location = useLocation();
    const address = location.state?.address
    const addressId = address?.addressId

    const navigate = useNavigate();

    useEffect ( () => {
        if(address) {
            setAddressLine(address.addressLine || "" )
            setCity(address.city || "" )
            setCountry(address.country || "" )
            setPincode(address.pincode || "" )
            setStreet(address.street || "" )
            setState( address.state || "" )
        }
    }, [address] )

    const handleAddressUpdate = async (e) => {
        e.preventDefault();

        try {
            await API.put(`/api/address/update/${addressId}`, {
                city,
                pincode,
                street,
                addressLine,
                country,
                state
            })
            alert("Address Updated Successfully")
            navigate("/")
            console.log("Address Updated Successfully")
        } catch (error) {
            console.log(error)
        }
    }


    return (
        <div className="container d-flex justify-content-center mt-5">
            <div
                className="card shadow p-4"
                style={{ width: "450px", borderRadius: "10px" }}
            >
                <h4 className="mb-3 fw-bold">Update Address</h4>

                <form onSubmit={handleAddressUpdate}>

                    <div className="mb-3">
                        <label className="form-label">Address Line</label>
                        <textarea
                            value={addressLine}
                            onChange={(e) => setAddressLine(e.target.value)}
                            className="form-control"
                            rows="2"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Street</label>
                        <input
                            type="text"
                            value={street}
                            onChange={(e) => setStreet(e.target.value)}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">City</label>
                            <input
                                type="text"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Pincode</label>
                            <input
                                type="text"
                                value={pincode}
                                onChange={(e) => setPincode(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">State</label>
                            <input
                                type="text"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Country</label>
                            <input
                                type="text"
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>
                    </div>

                    <button
                        className="btn w-100 mt-3"
                        style={{
                            backgroundColor: "#FFD814",
                            border: "none",
                            fontWeight: "bold"
                        }}
                    >
                        Update Address
                    </button>
                </form>
            </div>
        </div>
    );
}

export default UpdateAddress;